import Keycloak from 'keycloak-js'
import React, { createContext, ReactNode } from 'react'
import { KeycloakVO } from '@repo/types'

export interface KeycloakCurrentUser {
  lastName: string
  name: string
  email: string
  keycloakId: string
}

interface KeycloakContextProps {
  info: KeycloakVO
  instance: Keycloak
  currentUser: KeycloakCurrentUser
}

export const KeycloakContext = createContext<KeycloakContextProps | null>(null)

interface KeycloakProviderProps {
  info: KeycloakVO
  instance: Keycloak
  children: ReactNode
}

export interface KeycloakUserInfo {
  family_name: string
  given_name: string
  name: string
  preferred_username: string
  sub: string
}

export const KeycloakProvider = ({ children, info, instance }: KeycloakProviderProps) => {
  const user = instance.userInfo as KeycloakUserInfo

  const currentUser: KeycloakCurrentUser = {
    name: user.name,
    lastName: user.family_name,
    email: user.preferred_username,
    keycloakId: user.sub
  }

  return (
    <KeycloakContext.Provider
      value={{
        info,
        instance,
        currentUser
      }}
    >
      {children}
    </KeycloakContext.Provider>
  )
}
